import React from 'react';
import PropTypes from 'prop-types';
import Usdc from '../assets/usd-coin-usdc-logo.png';
import Eth from '../assets/eth-logo.png';
import { Form, Button, Loader } from 'rimble-ui';

const RightInfoBox = ({ ffunction, faucetLoading, ethtoUsdc, chainID, gasPrice, blockNumber }) => {
	return (
		<div
			style={{
				right: '0px',
				bottom: '0px',
				position: 'absolute',
				margin: '10px',
				display: 'block',
				marginBottom: '40px'
			}}
		>
			{(chainID === 3 && (
				<Form>
					<Button size="small" onClick={ffunction}>
						{!faucetLoading && <p>Get USDC</p>}
						{faucetLoading && <Loader color="white" />}
					</Button>
				</Form>
			)) ||
				(chainID === 1 && (
					<Button
						as="a"
						size="small"
						target="_blank"
						rel="noopener noreferrer"
						href="https://www.coinbase.com/"
					>
						Get USDC
					</Button>
				))}
			<pre>
				<a
					style={{
						color: 'white'
					}}
					target="_blank"
					rel="noopener noreferrer"
					href="https://www.coinbase.com/price/ethereum"
				>
					ETH <img alt="ETH" style={{ width: '23px' }} src={Eth} /> / USDC{' '}
					<img alt="USDC" style={{ width: '23px' }} src={Usdc} /> : {ethtoUsdc}
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: '#61dafb',
						marginTop: '10px',
						display: 'block'
					}}
					href="https://ethereum.org"
				>
					<span role="img" aria-label="unicorn">
						🦄
					</span>{' '}
					Chain ID : {chainID}{' '}
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: '#61dafb',
						marginTop: '10px',
						display: 'block'
					}}
					href="https://www.etherscan.io/gastracker"
				>
					<span role="img" aria-label="gasstation">
						⛽
					</span>{' '}
					Gas price : {gasPrice} gwei{' '}
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: '#61dafb',
						marginTop: '10px',
						display: 'block'
					}}
					href="https://www.etherscan.io/blocks"
				>
					<span role="img" aria-label="blocks">
						🧱
					</span>{' '}
					Current block : {blockNumber}
				</a>
			</pre>
		</div>
	);
};

RightInfoBox.propTypes = {
	ethtoUsdc: PropTypes.string,
	chainID: PropTypes.number,
	gasPrice: PropTypes.string,
	blockNumber: PropTypes.number
};

export default RightInfoBox;
